import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const containerCss = css([
  {
    display: "inline",
    color: tokens.color.text.tertiary.default.value,
  },
  fontSize(13),
]);

export const locationCss = css([
  {
    display: "inline",
  },
  {
    ".group-icon-wrapper .ks": {
      marginRight: "3px",
      verticalAlign: "-2px",
      fill: tokens.color.symbol.tertiary.default.value,
      "&:hover": {
        fill: tokens.color.symbol.tertiary.default.value,
      },
    },
    ".group-icon-wrapper .fa-users": {
      marginRight: "3px",
      color: tokens.color.symbol.brand.default.value,
    },
  },
]);

export const folderPathCss = css([
  {
    display: "inline",
  },
  {
    ".folder-icon-wrapper .ks-folder": {
      marginRight: "3px",
      verticalAlign: "-2px",
      fill: tokens.color.symbol.icon.green.value,
    },
  },
]);
